// extracted by mini-css-extract-plugin
module.exports = {"info":"PomoInfo_info__3Xo8r","more":"PomoInfo_more__3hsxt"};